import { useTransaction } from '@/hooks/useTransaction/useTransaction';
import { cn } from '@/utils/cn';
import { Container, TextLabel } from '@cof/omni-react';

// cardLast4Array will contain exactly one value for 3ds
const formatCardNumbers = (cardArray?: string[] | string) => {
  if (!cardArray) return '';
  const value = Array.isArray(cardArray) ? cardArray[0] : cardArray;
  return value ? `**** ${value}` : '';
};

export const TransactionDetails = () => {
  const { publicData } = useTransaction();

  return (
    <Container
      data-testid="TransactionDetails"
      className={cn('bg-page', 'text-neutral-primary')}
      padding="medium"
      borderRadius="large"
      variant="contentWithBorderSubtle"
    >
      <Container paddingBottom="medium">
        <TextLabel color="secondary">Purchase Amount</TextLabel>
        <Container paddingTop="tiny">{publicData.purchaseAmount}</Container>
      </Container>
      <Container paddingBottom="medium">
        <TextLabel color="secondary">Merchant</TextLabel>
        <Container paddingTop="tiny">{publicData.merchantName}</Container>
      </Container>
      <Container>
        <TextLabel color="secondary">Card Number</TextLabel>
        <Container paddingTop="tiny">
          {formatCardNumbers(publicData.cardLast4Array)}
        </Container>
      </Container>
    </Container>
  );
};
